import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ScreenTopBar from '@coeldery/screen-top-bar';
/** ⭐ 0019（`decisions/043`）：意見回饋卡 */
import MeFeedbackCard from '../components/MeFeedbackCard';
import DeviceRestore from '../components/DeviceRestore';
import BillingSection from '../features/me/BillingSection';
import { currentBundleName } from '../features/settings/appInfo';

/**
 * 「我的」＝ **付款管理 ＋ 恢復我嘅歌**（UI v2 **步 9**；設計 §11：帳號部分搬去「設定」）
 *
 * ⚠️ 硬規則 B（`P-90`）：頁面 ≤200 行 → 付款卡已拆去 `features/me/BillingSection.tsx`。
 * ⚠️ **唔准假成功**：收款未接通 → 照實顯示（`decisions/028`）。
 */

const card: React.CSSProperties = {
  background: 'var(--color-card)',
  border: '1px solid var(--color-divider)',
  borderRadius: '18px',
  padding: '14px 16px',
  marginBottom: '12px',
};
const h2: React.CSSProperties = { margin: '0 0 8px', fontSize: 'var(--font-size-label, 16px)' };
const btn: React.CSSProperties = {
  minHeight: '40px',
  padding: '0 16px',
  borderRadius: '20px',
  border: '1.5px solid var(--color-primary)',
  background: 'var(--color-primary)',
  color: 'var(--color-on-primary)',
  fontFamily: 'inherit',
  fontSize: 'var(--font-size-small, 15px)',
  fontWeight: 700,
  cursor: 'pointer',
};

export default function MePage() {
  const { t, i18n } = useTranslation();
  const [bundleName] = useState(() => currentBundleName());

  return (
    <div className="page">
      <ScreenTopBar title={t('tab_me')} />
      <div className="page__scroll" style={{ padding: '12px' }}>
        {/* ⭐ 0019：意見回饋（Beta 測試期；UX 升級用） */}
        <MeFeedbackCard
          locale={String(i18n.language ?? 'zh-HK')}
          appVersion={bundleName}
          cardStyle={card}
          headingStyle={h2}
          buttonStyle={btn}
        />

        {/* ── 付款管理（HK 網上收款）── */}
        <BillingSection />

        {/* ── ⭐ 恢復我嘅歌（共用元件 `DeviceRestore`）── */}
        <DeviceRestore />
      </div>
    </div>
  );
}
